/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Retail {

    import fld = POSApprovalReturnItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class POSApprovalReturnItemsEditor extends _Ext.ItemGridEditor<POSApprovalReturnItemsRow> {


        protected getColumnsKey() { return "Retail.POSApprovalReturnItems"; }
        protected getDialogType() { return POSApprovalReturnItemsDialog; }
        protected getLocalTextPrefix() { return POSApprovalReturnItemsRow.localTextPrefix; }
        protected form: POSApprovalReturnItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }


        // #region Variables
        public PartyId: number;
        public CustomerId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public TransDate: Date;
        public ExchangeRate: number;
        public TotalItems: number;
        public ProductTypeId: number; 

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as POSApprovalReturnDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            })

        }

        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        } 

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Discount).format = num;
            Q.first(columns, x => x.field === fld.DiscountPer).format = num;

            Q.first(columns, x => x.field === fld.Pieces).format = int;
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Weight).format = wt;

           
            let EditGrossAmount = q.ToBool(GetConfigValue(1030)); 
            if (EditGrossAmount) {
                var GrossAmount = Q.first(columns, x => x.field === fld.GrossAmount);
                GrossAmount.referencedFields = [fld.GrossAmount];
                GrossAmount.format = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            }

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        // #endregion

        setMasterValues() {
            this.RateListId = (this.parentDialog as POSApprovalReturnDialog).RateListId;
            this.LaborListId = (this.parentDialog as POSApprovalReturnDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as POSApprovalReturnDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as POSApprovalReturnDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as POSApprovalReturnDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as POSApprovalReturnDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as POSApprovalReturnDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as POSApprovalReturnDialog).form.TransDate.valueAsDate;
            this.CustomerId = parseInt((this.parentDialog as POSApprovalReturnDialog).form.POSCustomerId.value);
        }
        public callrefresh() {
            this.view.refresh();
        }

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }

        //#region  ItemGrid Inline Editor

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            let _value = ValidateEditorFields(field, input, text, oldText);
            let value: number;
            if (q.isNumber(_value))
                value = parseFloat(_value.toString());
            else
                return false;

            let CurrentStock: Stock.StockItemRow;
            var partyid = this.CustomerId;
            Stock.StockItemService.GetReturnValues({
                ProductId: item.ProductId,
                Line_No: item.Line_No,
                SKU: item.SKU,
                BagNo: item.BagNo,
                POSCustomerId: partyid,
                VoucherTypeId: 101,
                RefVoucherTypeId: 92
            },
                response =>
                    CurrentStock = response.Entity,
                { async: false });

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {
                if (value > CurrentStock.Pieces) {
                    Q.alert('Not Enough Stock');
                    item[field] = CurrentStock.Pieces;
                    item.Weight = CurrentStock.Weight;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }

            }

            //}

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0 && item.ItemTypeId != 101) {
                if (value > CurrentStock.Pieces) {
                    Q.alert('Not Enough Stock');
                    item[field] = CurrentStock.Pieces;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;
                }
                item[field] = value;
            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {
                if (value > CurrentStock.Weight) {
                    Q.alert('Not Enough Stock');
                    item[field] = CurrentStock.Weight;
                    item.Pieces = CurrentStock.Pieces;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId != 3) {
                    var Net = ((item.UnitRate + item.UnitLabour) / item.Weight) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // **** Calculate Amount based on UnitRate and Weight or Pieces
            if (field === fld.UnitRate && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Weight * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }
                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Pieces * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }

                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                var laboramount = item.UnitLabour;
                if (value > laboramount) {

                    q.Warning('', 'Discount cannot be greater than Labor Amount', true);
                    item[field] = 0;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                Common.CommonService.GetItemDiscount({
                    Discount: value,
                    LaborDetails: item.LaborDetails
                }, response => {
                    var x = response;
                    if (response.Entities == null) {
                        q.Warning('', 'Discount Policies will be affected, cannot apply Discount', true);
                        item[field] = 0;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                        return;
                    }
                    if (response.Entities.length > 0) {
                        var labors = response.Entities;
                        item.LaborDetails = labors;
                        item[field] = value;
                        this.view.updateItem(id, item);
                        this.view.refresh();
                        item.GrossAmount = item.GrossAmount - value;
                        item.DiscountPer = (value / item.NetAmount) * 100;
                        //this.form.LaborDetails.setData(labors);
                    }
                }, { async: false })
                //Q.reloadLookup(Administration.ItemDiscountDetailsRow.lookupKey);
                //var DiscountPer = (value / item.NetAmount) * 100;
                //try {
                //    var AllowedDiscount = Q.tryFirst(Administration.ItemDiscountDetailsRow.getLookup().items, x => x.Id == 2 && x.ProductTypeId == item.ProductTypeId).MaxDiscount;

                //}
                //catch (undefined) {
                //    AllowedDiscount = 100000;
                //}

                //if (AllowedDiscount != undefined && DiscountPer <= AllowedDiscount) {
                //    item.GrossAmount = item.NetAmount - value;
                //    item.DiscountPer = (value / item.NetAmount) * 100;
                //    item[field] = value;
                //    var Fancy = item.LaborDetails.filter(x => x.ProcessName == "Fancy Charges");
                //    var Balance = 0;
                //    if (Fancy.length > 0) {
                //        if (value > Fancy[0].LabourAmount) {
                //            Balance = value - Fancy[0].LabourAmount;
                //            Fancy[0].LabourAmount = 0;
                //            Fancy[0].LabourRate = 0;
                //        }
                //        else {
                //            Fancy[0].LabourAmount = Fancy[0].LabourAmount - value;
                //            Fancy[0].LabourRate = Fancy[0].LabourAmount / Fancy[0].Weight;
                //        }
                //        if (Balance > 0) {

                //            var Making = item.LaborDetails.filter(x => x.ProcessName == "Making Charges");
                //            Making[0].LabourAmount = Making[0].LabourAmount - Balance;
                //            Making[0].LabourRate = Making[0].LabourAmount / Making[0].Weight;
                //        }
                //    }
                //    else {

                //        var Making = item.LaborDetails.filter(x => x.ProcessName == "Making Charges");
                //        if (value < Making[0].LabourAmount) {
                //            Making[0].LabourAmount = Making[0].LabourAmount - value;
                //            Making[0].LabourRate = Making[0].LabourAmount / Making[0].Weight;
                //        }
                //        else
                //            q.Warning("Not Allowed", "Discount value is more than Making Charges", false);

                //    }

                //    var lamount = 0;
                //    item.LaborDetails.forEach(function (x) {
                //        lamount += x.LabourAmount;
                //    });
                //    item.UnitLabour = lamount;

                //}
                //else {
                //    Q.warning(q.text('Message.Discount.NotAllowed', 'You are not Authorized to give that much discount'))
                //}

            }

            // *** Calculate Discount % ***
            if (field === fld.DiscountPer && value >= 0) {
                var Discount = (item.NetAmount * value) / 100
                var laboramount = item.UnitLabour;
                if (Discount > laboramount) {

                    q.Alert('', 'Discount cannot be greater than Labor Amount', 2999, true);
                    item[field] = 0;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                Common.CommonService.GetItemDiscount({
                    Discount: Discount,
                    LaborDetails: item.LaborDetails
                }, response => {
                    if (response.Entities == null) {
                        q.Alert('', 'Discount Policies will be affected, cannot apply Discount', 2999, true);
                        item[field] = 0;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                        item.GrossAmount = item.GrossAmount - value;
                        item.DiscountPer = (value / item.NetAmount) * 100;
                        return;
                    }
                    if (response.Entities.length > 0) {
                        var labors = response.Entities;
                        item.LaborDetails = labors;
                        item[field] = value;
                        this.view.updateItem(id, item);
                        this.view.refresh();
                        var Discount = (item.NetAmount * value) / 100
                        item.GrossAmount = item.NetAmount - Discount;
                        item.Discount = Discount;
                        //this.form.LaborDetails.setData(labors);
                    }
                }, { async: false })


            }

            // *** Calculate Discount   ***
            if (field === fld.GrossAmount && value >= 0) {
                var Discount = value - (item.NetAmount + item.UnitLabour);
                var laboramount = item.UnitLabour;
                if (Discount > laboramount) {

                    q.Alert('', 'Discount cannot be greater than Labor Amount', 2999, true);
                    item[field] = 0;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                Common.CommonService.GetItemDiscount({
                    Discount: Discount,
                    LaborDetails: item.LaborDetails
                }, response => {
                    if (response.Entities == null) {

                        q.Alert('', 'Discount Policies will be affected, cannot apply Discount', 2999, true);
                        item[field] = 0;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                        return;
                    }
                    if (response.Entities.length > 0) {
                        var labors = response.Entities;
                        item.LaborDetails = labors;
                        item[field] = value;
                        item.Discount = Discount;
                        item.DiscountPer = (Discount / item.NetAmount) * 100;
                        this.view.updateItem(id, item);
                        this.view.refresh();
                        //this.form.LaborDetails.setData(labors);
                    }
                }, { async: false })



            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;
            }

            item.UnitCost = item.CalcOnId == 3 ? (item.UnitRate + item.UnitLabour) / item.Pieces : (item.UnitRate + item.UnitLabour) / item.Weight;
            item.CCGrossAmount = item.GrossAmount * this.ExchangeRate;
            item.CCNetAmount = item.NetAmount * this.ExchangeRate;

            this.view.updateItem(id, item);
            this.view.refresh();

            (this.parentDialog as POSApprovalReturnDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);



            let returnvalue: string = ""; 
            if (input.hasClass('numeric'))
                returnvalue = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                returnvalue = Q.formatNumber(value, '0');

            if (input.hasClass('weight'))
                returnvalue = Q.formatNumber(value, '0.000');

            if (input.hasClass('amount'))
                returnvalue = q.formatAmount(value);

            input.val(returnvalue).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        //#endregion


        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Retail.POSApprovalSelectGrid

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Items",
                cssClass: "stock-button",
                hotkey: 'alt+k',
                hint: 'alt+k',
                onClick: () => {
                    this.setMasterValues();
                    //// **** Validate Party before Item Selection ****
                    //if (isNaN(this.PartyId)) {
                    //    Q.notifyWarning("Please select Customer to proceed");
                    //    return;
                    //}
                    //else {
                    var filters: _Ext.SelectGridFilters = {
                        CustomerId: this.CustomerId
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    //}
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetSalesItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        this.setData(ItemDetails);
                    }

                    pickerDialog.element.bind('dialogclose', () => {

                        this.element.trigger('dialogclose');

                    });
                    pickerDialog.dialogOpen();

                },
                disabled: this.readOnly ? true : false
            });

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            return buttons;
        }
        // #region Set Data

        setData(ItemDetails: any[]) {
            if (this.view.getItems().length > 0) {
                this.TotalItems = ItemDetails.length + this.view.getItems().length;
            }
            else {
                this.TotalItems = ItemDetails.length;
            }
            for (let Itemdetail of ItemDetails) {
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }

        // #endregion
    }
}